const Allowance = {
  YearAndMonthDescription: "Allowance.YearAndMonthDescription",
  CommentDescription: "Allowance.CommentDescription",
  MealTitle: "Allowance.MealTitle",
  MealDescription: "Allowance.MealDescription",
  NameOfDeviationDescription: "Allowance.NameOfDeviationDescription",
  }
export default Allowance;